// api should be here
import { http } from '@/utils/http';
import qs from 'qs';
// 活动api baseurl
const urlPrefix =
  'vote/2020project/2020chongqing_football/controller.php?enews=';

const getBaseInfo = () => {
  return http.get(`${urlPrefix}base-info`);
};
const voteList = () => {
  return http.get(`${urlPrefix}vote-list`);
};
const vote = () => {
  return http.get(`${urlPrefix}vote`);
};
const getRule = () => {
  return http.get(`${urlPrefix}rules`);
};
export { getBaseInfo, voteList, vote, getRule };
